import { Component, OnInit } from '@angular/core';
import {StockApiService} from '../../services/stock-api.service';
import {AppComponent} from '../../app.component';
import {AdobeService} from '../../services/adobe.service';
import {BlueKaiService} from '../../services/blue-kai.service';
import {TitleService} from '../../services/title.service';
import {BrandService} from '../../services/brand.service';
import {QueryStringService} from '../../services/query-string.service';

@Component({
  selector: 'app-dealer-list',
  templateUrl: './dealer-list.component.html',
})
export class DealerListComponent implements OnInit {

  dealers: Dealer[] = [];
  brandSlug: string;
  vehicleType = '';

  constructor(private stockApiService: StockApiService,
              private adobeService: AdobeService,
              private blueKaiService: BlueKaiService,
              private titleService: TitleService,
              private QSS: QueryStringService,
  ) {
    this.titleService.setTitleDealerList();

    this.brandSlug = BrandService.getCurrentBrand().slug;
    window.scroll(0, 0);
    if (this.brandSlug === 'fiat' || this.brandSlug === 'fiat-professional') {
      if (this.brandSlug === 'fiat') {
        if (this.QSS.getParam('type')) {
          this.vehicleType = this.QSS.getParam('type').toString().toLowerCase() === 'dostawcze' ? 'dostawcze' : 'osobowe';
        } else if (AppComponent.vehicleType === 'dostawcze') {
          this.vehicleType = 'dostawcze';
          this.QSS.setParam('type', 'dostawcze');
        } else {
          this.vehicleType = 'osobowe';
        }
      } else if (this.brandSlug === 'fiat-professional') {
        if (this.QSS.getParam('type')) {
          this.vehicleType = this.QSS.getParam('type').toString().toLowerCase() === 'osobowe' ? 'osobowe' : 'dostawcze';
        } else {
          this.vehicleType = 'dostawcze';
        }
      }

      setTimeout(() => {
        AppComponent.vehicleType = this.vehicleType;
      });

      if (this.vehicleType === 'osobowe') {
        this.getDealerList('fiat');
      } else if (this.vehicleType === 'dostawcze') {
        this.getDealerList('fiat-professional');
      }
    } else {
      this.getDealerList(this.brandSlug);
    }
  }

  ngOnInit() {
    setTimeout(() => {
      AppComponent.bodyClass = 'page';
      this.adobeService.pageLoadDealerList();
      this.blueKaiService.changeRoute();
    });
  }

  getDealerList(brandSlug) {
    this.stockApiService.getDealerList(brandSlug).then(value => {
      this.dealers = value;
    });
  }
  changeVehicleType(val: string) {
    if (this.vehicleType !== val) {
      AppComponent.vehicleType = val;
      this.QSS.setParam('type', val);
      this.vehicleType = val;
      if (this.vehicleType === 'osobowe') {
        this.getDealerList('fiat');
      } else if (this.vehicleType === 'dostawcze') {
        this.getDealerList('fiat-professional');
      }
    }
  }
}

interface Coordinates {
  longitude: number;
  latitude: number;
}

interface Dealer {
  code: string;
  name: string;
  offer_count: number;
  subdealer: boolean;
  locations: Location[];
}

interface Location {
  sitecode: string;
  street: string;
  post_code: string;
  city: string;
  region: string;
  coordinates: Coordinates;
  website: string;
  email: string;
  phones: string[];
  communicators: Communicator[];
}
interface Communicator {
  name: string;
  id: string;
}
